import PaymentService from "../../services/httpServices/payment.service";
import SubscriptionFailureModal from "./SubscriptionFailureModalParent";
import { useAuth } from "../../contexts/authContext";
import UtilityService from "../../services/utils.service";

type OptionalFunctionType = () => void;

interface NoSubscriptionModalProps {
  onClose?: OptionalFunctionType | null;
}

const NoSubscriptionModal: React.FC<NoSubscriptionModalProps> = ({ onClose }) => {
  const { paymentHelper } = UtilityService();

  const auth = useAuth();

  return (
    <SubscriptionFailureModal
      onClose={() => onClose?.()}
      title="No estás suscrito"
      description="Suscríbete para poder realizar test"
      actionText="Suscribirme"
      actionFunction={async () => { await paymentHelper(auth.user.email) }}
    />
  );
};

const NoPaidModal: React.FC<NoSubscriptionModalProps> = ({ onClose }) => {
  const { billingDashboard } = PaymentService();

  return (
    <SubscriptionFailureModal
      onClose={() => onClose?.()}
      title="Problema con tus datos de pago"
      description="Suscríbete para poder realizar test"
      actionText="Revisar datos de pago"
      actionFunction={async () => {
        const url = await billingDashboard()
        window.location.href = url
      }}
    />
  );
};


const TrialModeFinished: React.FC<NoSubscriptionModalProps> = ({ onClose }) => {
  const { paymentHelper } = UtilityService();

  const auth = useAuth();

  return (
    <SubscriptionFailureModal
      onClose={() => onClose?.()}
      title="Tu periodo de prueba ha vencido"
      description="Suscríbete para poder realizar test"
      actionText="Suscribirme"
      actionFunction={async () => { await paymentHelper(auth.user.email) }}
    />
  );
};

export { NoSubscriptionModal, NoPaidModal, TrialModeFinished };
